import * as lodash from '../../utils/lodash';
export function horizontalLayout(props) {
    var layoutWidthLimit = props.layoutWidthLimit, legendItemList = props.legendItemList, option = props.option, layoutBox = props.layoutBox, rtl = props.rtl, paginationWidth = props.paginationWidth;
    var scrollable = option.scrollable, itemGap = option.itemGap, scrollLineClamp = option.scrollLineClamp;
    var paddingTop = layoutBox.paddingTop, paddingLeft = layoutBox.paddingLeft, paddingRight = layoutBox.paddingRight, paddingBottom = layoutBox.paddingBottom;
    var legendPages = [[]];
    if (legendItemList.length === 0) {
        return {
            width: 0,
            height: 0,
        };
    }
    var currentPage = 0;
    var currentRow = 1;
    var currentPageWidth = paddingLeft + paddingRight;
    var currentItems = legendPages[0];
    var colGap = lodash.isNumber(itemGap) ? itemGap : itemGap[0];
    var rowGap = lodash.isNumber(itemGap) ? itemGap : itemGap[1];
    var x = paddingLeft;
    var y = paddingTop;
    var legendWidth = paddingLeft + paddingRight;
    var legendHeight = 0;
    var totalWidth = paddingLeft;
    legendItemList.forEach(function (legendItem, index) {
        var gap = index !== legendItemList.length - 1 ? colGap : 0;
        totalWidth += legendItem.width + gap;
    });
    var isOverflow = totalWidth > layoutWidthLimit + paginationWidth;
    legendItemList.forEach(function (legendItem) {
        var width = legendItem.width, height = legendItem.height;
        var isFirstItem = currentItems.length === 0;
        var isEnoughSpace = !(currentPageWidth + width + colGap > layoutWidthLimit + (isOverflow ? 0 : paginationWidth));
        if (isFirstItem) {
            isEnoughSpace = true;
        }
        if (!isEnoughSpace) {
            x = paddingLeft;
            if (!isFirstItem) {
                if (!scrollable) {
                    y += height + rowGap;
                }
                else if (currentRow < scrollLineClamp) {
                    y += height + rowGap;
                }
                else {
                    y = paddingTop;
                }
            }
            legendItem.x = x;
            legendItem.y = y;
            currentPageWidth = width + paddingLeft + paddingRight;
            if (!isFirstItem && (!scrollable || currentRow >= scrollLineClamp)) {
                // next page
                currentRow = 0;
                legendPages.push([]);
                currentPage++;
                currentItems = legendPages[currentPage];
            }
            currentItems.push(legendItem);
            x += width + colGap;
            if (scrollable) {
                currentRow++;
            }
        }
        else {
            // enough space
            legendItem.x = x;
            legendItem.y = y;
            currentItems.push(legendItem);
            var currentColGap = x === paddingLeft ? 0 : colGap;
            x += width + colGap;
            currentPageWidth += width + currentColGap;
        }
    });
    legendPages.forEach(function (pageItems, pageIndex) {
        pageItems.forEach(function (item) {
            item.pageIndex = pageIndex;
        });
        var pageWidth = lodash.max(pageItems.map(function (item) { return item.x + item.width; })) + paddingRight;
        var pageHeight = lodash.max(pageItems.map(function (item) { return item.y + item.height; })) + paddingBottom;
        legendWidth = Math.max(pageWidth, legendWidth);
        legendHeight = Math.max(pageHeight, legendHeight);
    });
    if (rtl) {
        legendItemList.forEach(function (legendItem) {
            legendItem.x = legendItem.x + (legendWidth / 2 - legendItem.x) * 2 - legendItem.width;
        });
    }
    return {
        width: legendWidth,
        height: legendHeight,
    };
}
export function verticalLayout(props) {
    var layoutHeightLimit = props.layoutHeightLimit, legendItemList = props.legendItemList, option = props.option, layoutBox = props.layoutBox, rtl = props.rtl;
    var scrollable = option.scrollable, itemGap = option.itemGap, scrollLineClamp = option.scrollLineClamp;
    var paddingTop = layoutBox.paddingTop, paddingLeft = layoutBox.paddingLeft, paddingRight = layoutBox.paddingRight, paddingBottom = layoutBox.paddingBottom;
    var legendPages = [[]];
    if (legendItemList.length === 0) {
        return {
            width: 0,
            height: 0,
        };
    }
    var currentPage = 0;
    var currentRow = 1;
    var currentPageHeight = paddingTop + paddingBottom;
    var currentItems = legendPages[0];
    var colGap = lodash.isNumber(itemGap) ? itemGap : itemGap[0];
    var rowGap = lodash.isNumber(itemGap) ? itemGap : itemGap[1];
    var x = paddingLeft;
    var y = paddingTop;
    var legendHeight = paddingTop + paddingBottom;
    var legendWidth = paddingLeft + paddingRight;
    legendItemList.forEach(function (legendItem) {
        var height = legendItem.height;
        if (currentPageHeight + height + rowGap > layoutHeightLimit) {
            if (y === paddingTop) {
                legendItem.x = x;
                legendItem.y = y;
                currentItems.push(legendItem);
            }
            else {
                // next page
                var colWidth = lodash.max(currentItems.map(function (item) { return item.width; }));
                if (!scrollable) {
                    x += colWidth + colGap;
                }
                if (scrollable) {
                    if (currentRow < scrollLineClamp) {
                        x += colWidth + colGap;
                    }
                    else {
                        x = paddingLeft;
                    }
                }
                y = paddingTop;
                legendItem.x = x;
                legendItem.y = y;
                currentPageHeight = height + paddingBottom + paddingTop;
                if (!scrollable || currentRow >= scrollLineClamp) {
                    currentRow = 0;
                    legendPages.push([]);
                    currentPage++;
                    currentItems = legendPages[currentPage];
                }
                currentItems.push(legendItem);
                y += height + rowGap;
            }
            if (scrollable) {
                currentRow++;
            }
        }
        else {
            // enogugh space
            legendItem.x = x;
            legendItem.y = y;
            currentItems.push(legendItem);
            var currentRowGap = y === paddingTop ? 0 : rowGap;
            y += height + rowGap;
            currentPageHeight += height + currentRowGap;
        }
    });
    legendPages.forEach(function (pageItems, pageIndex) {
        pageItems.forEach(function (item) {
            item.pageIndex = pageIndex;
        });
        var pageHeight = lodash.max(pageItems.map(function (item) { return item.y + item.height; })) + paddingBottom;
        var pageWidth = lodash.max(pageItems.map(function (item) { return item.x + item.width; })) + paddingRight;
        legendHeight = Math.max(pageHeight, legendHeight);
        legendWidth = Math.max(pageWidth, legendWidth);
    });
    if (rtl) {
        legendItemList.forEach(function (legendItem) {
            legendItem.x = legendItem.x + (legendWidth / 2 - legendItem.x) * 2 - legendItem.width;
        });
    }
    return {
        width: legendWidth,
        height: legendHeight,
    };
}
